/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import placeholder from "./placeholder-img.png";

interface Props extends React.ImgHTMLAttributes<HTMLImageElement> {
  dataTestId?: string;
  disable?: boolean;
}

export default (props: Props) => {
  const { dataTestId, disable, ...forwardProps } = props;

  return disable ? (
    <img {...forwardProps} data-testid={dataTestId} />
  ) : (
    <img
      {...forwardProps}
      data-testid={dataTestId}
      loading="lazy"
      onError={(e) => {
        e.currentTarget.src = placeholder;
      }}
    />
  );
};
